"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePerfGroupTimeChart = void 0;
const react_hooks_1 = require("@apollo/react-hooks");
const ChartingPalette_1 = __importDefault(require("@opsbase/lib-palette/ChartingPalette"));
const calcTimeInterval_1 = __importDefault(require("@opsbase/lib-time/helpers/calcTimeInterval"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/useSelf"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = require("react");
function usePerfGroupTimeChart(dimension, measure, interval) {
    const [changed, setChanged] = (0, react_1.useState)();
    const loading = (0, react_1.useRef)(true);
    const data = (0, react_1.useRef)([]);
    const state = (0, react_1.useRef)({});
    const self = (0, useSelf_1.default)();
    const skip = state.current.self === self &&
        state.current.dimension === dimension &&
        state.current.measure === measure &&
        state.current.interval === interval;
    const { loading: gqlLoading, data: gqlData } = (0, react_hooks_1.useQuery)((0, graphql_tag_1.default) `
			query calcPerfGroupTimeChartData(
				$dimension: String!
				$measure: String!
				$interval: String!
			) {
				calcPerfGroupTimeChartData(
					dimension: $dimension
					measure: $measure
					interval: $interval
				)
			}
		`, {
        variables: { dimension, measure, interval },
        skip,
    });
    // --------------------
    // This is the primary part of the hook
    // It parses the rawData into data that can be used by the charts
    (0, react_1.useEffect)(() => {
        if (skip)
            return;
        if (gqlLoading) {
            if (!loading.current) {
                loading.current = true;
                setChanged(new Date());
            }
            return;
        }
        loading.current = false;
        state.current = { dimension, measure, interval };
        const rawData = (gqlData === null || gqlData === void 0 ? void 0 : gqlData.calcPerfGroupTimeChartData) || [];
        const palette = ChartingPalette_1.default.generatePalette(rawData.length);
        data.current = rawData.map((y, yIdx) => y.values.map((x, xIdx) => generateDatum(xIdx, x, yIdx, y, interval, palette)));
        setChanged(new Date());
    }, [skip, gqlLoading, gqlData, dimension, measure, interval, self]);
    // --------------------
    return (0, react_1.useMemo)(() => ({
        loading: loading.current,
        data: data.current,
    }), 
    // eslint-disable-next-line
    [changed, self]);
}
exports.usePerfGroupTimeChart = usePerfGroupTimeChart;
exports.default = usePerfGroupTimeChart;
function generateDatum(xIdx, x, yIdx, y, interval, palette) {
    const xM = (0, moment_timezone_1.default)(x.key);
    const { label: xStr } = (0, calcTimeInterval_1.default)(interval, xM);
    const value = x.percent || 0;
    return {
        label: value + '% for ' + y.title,
        color1: palette[yIdx].main,
        color2: palette[yIdx].dark,
        x: xIdx + 1,
        xDim: { id: x.key, label: xStr.split(' - ').join('\n') },
        y: value,
        yRaw: value,
        yDim: { id: y.id, label: y.title },
    };
}
